<template>
  <div class="columns">
    <div class="column is-half">
      <b-notification type="is-warning" has-icon>
        This is the raid guide index.
      </b-notification>
      <router-link :to="{name: 'guide-mechanic-designer'}">
        Mechanic Designer
      </router-link>
    </div>
    <div class="column is-half">
      <b-notification type="is-warning" has-icon>
        This is the raid guide index.
      </b-notification>
    </div>
  </div>
</template>

<script>
export default {
  name: "RaidGuideIndex",
}
</script>

<style scoped>

</style>